import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import InvoiceManagementTable from "./table"

const InvoiceManagement = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Invoices"} />
          <InvoiceManagementTable />
        </Container>
      </div>
    </>
  )
}

export default InvoiceManagement
